const ACTIVE_CLASS = 'is-active';
const CLICKED_CLASS = 'clicked';
const BINDED_CLASS = 'binded';
const ONE_AT_A_TIME = 'js-dropdown-is-alone';
const FORCE_HEIGHT = 'js-dropdown-force-height';

import store from '../util/store';
import {scrollTo, getTop, getHeaderHeight} from '../functions';

export default class Dropdown {
  constructor($trigger) {
    this.$trigger = $trigger;
    this.bindTrigger(this.$trigger);
  }

  bindTrigger($trigger) {
    if ($trigger.classList.contains(BINDED_CLASS)) {
      return false;
    }

    $trigger.classList.add(BINDED_CLASS);

    $trigger.addEventListener('click', () => {
      this.onClick($trigger);
    });
  }

  onClick($trigger) {
    const submenuId = $trigger.dataset.submenu;
    $trigger.classList.toggle(CLICKED_CLASS);

    let $submenu = document.querySelector('.js-dropdown[data-trigger="' + submenuId + '"]');

    if(!$submenu || typeof $submenu === 'undefined') return false;

    const hasClass = $submenu.classList.toggle(ACTIVE_CLASS);
    if(hasClass && $trigger.classList.contains(ONE_AT_A_TIME)) {
      this.closeAllBut(submenuId);
    }

    if($submenu.classList.contains(FORCE_HEIGHT)) {
      if(hasClass) {

        let height = 0;
        const $heightsRefs = Array.from($submenu.querySelectorAll('.js-height'));
        $heightsRefs.map( $el => height += $el.offsetHeight);
        $submenu.style.height = height + 'px';
        setTimeout( () => {
          this.scrollToSubmenu($submenu);
        }, 500);
      } else {
        $submenu.style.height = '';
      }
    } else if (hasClass) {
      this.scrollToSubmenu($submenu);
    }
  }

  scrollToSubmenu($submenu) {
    let to = getTop($submenu) - getHeaderHeight();
    if(!store.bodyIsLocked()) {
      scrollTo({to: to});
    } else {
      scrollTo({to: to, $container: document.querySelector('.js-primary-menu')}); // specific to navbar menu
    }
  }

  closeAllBut(id) {
    let elements = this.getAllOthers(id);
    elements.triggers.map( $trigger => $trigger.classList.remove(CLICKED_CLASS));
    elements.dropdowns.map( $dropdown => {
      $dropdown.classList.remove(ACTIVE_CLASS)
      $dropdown.style.height = '';
    });
  }

  getAllOthers(id) {
    const triggers = Array.from(document.querySelectorAll('.js-dropdown-is-alone:not([data-submenu="' + id + '"]'));
    const dropdownsIds = triggers.map( $trigger => '.js-dropdown[data-trigger="' + $trigger.dataset.submenu + '"]');

    const dropdowns = dropdownsIds.length ? Array.from(document.querySelectorAll(dropdownsIds)) : [];
    return {dropdowns:dropdowns, triggers: triggers};
  }
}



// WEBPACK FOOTER //
// ./scripts/dom/Dropdown.js